import React, { useState } from 'react';

function AccordionBasic(props) {
  const [open, setOpen] = useState(props.status);

  return (
    <div className="px-4 py-3 rounded-xl bg-portal-100">
      <button
        className={`flex items-center justify-between w-full group mb-1 ${
          open && 'border-b border-gray-200'
        }`}
        aria-expanded={open}
        onClick={() => setOpen(!open)}>
        <div className="text-md text-portal-600 font-medium ">
          {props.title}
        </div>
        <svg
          className={`w-8 h-8 shrink-0 fill-current text-portal-600 group-hover:text-portal-600 ml-3 ${
            open && 'rotate-180'
          }`}
          viewBox="0 0 32 32">
          <path d="M16 20l-5.4-5.4 1.4-1.4 4 4 4-4 1.4 1.4z" />
        </svg>
      </button>
      <div className={`text-black text-sm ${!open && 'hidden'}`}>
        {props.children}
      </div>
    </div>
  );
}

export default AccordionBasic;
